import api from '@/api';

const documentMapper = (doc) => ({
    id: doc.id,
    title: doc.attributes.title,
    body: doc.attributes.body,
    link: doc.attributes.link
})

export default {
    namespaced: true,
    state: {
        documentList: []
    },
    getters: {
        getDocumentByLink: state => link => {
            return state.documentList.find(doc => doc.link === link)
        }
    },
    mutations: {
        setDocumentList(state, list) {
            state.documentList = list
        },
    },
    actions: {
        fetchDocumentList({ commit }) {
            return api.getDocuments(this.state.queryParams)
                .then(response => {
                    const documentList = response.data.data.map(documentMapper)
                    commit('setDocumentList', documentList)
                })
                .catch(console.error)
        }
    },
};
